import "@/styles/globals.css"
import "@/i18n"
import { RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { setSessionLostHandler } from "@/api/client"
import { sessionKeys } from "@/api/queries/session"
import { queryClient } from "@/api/query-client"
import { AppProviders } from "@/providers/app-providers"
import { createAppRouter } from "@/router"

const router = createAppRouter(queryClient)

// 401 anywhere → forget everything and go to /login, then come back here.
let redirecting = false
setSessionLostHandler(() => {
  if (redirecting || router.state.location.pathname === "/login") return
  redirecting = true
  const redirect = router.state.location.href
  queryClient.clear()
  queryClient.setQueryData(sessionKeys.all, undefined)
  void router.navigate({ to: "/login", search: { redirect, expired: true } }).finally(() => {
    redirecting = false
  })
})

const root = document.getElementById("root")
if (!root) throw new Error("#root element missing")

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
